<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">

            <el-form-item label="姓名：">
                <el-input v-model.trim="searchForm.userName" @keyup.enter.native="getListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.userPhone" @keyup.enter.native="getListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="公司名称：">
                <el-input v-model.trim="searchForm.accName" @keyup.enter.native="getListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="开户状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="通过" value="2"></el-option>
                    <el-option label="拒绝" value="3"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="报备状态：">
                <el-select v-model="searchForm.baoState" clearable>
                    <el-option label="未报备" value="0"></el-option>
                    <el-option label="报备中" value="1"></el-option>
                    <el-option label="报备通过" value="2"></el-option>
                    <el-option label="报备拒绝" value="3"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜索</el-button>
                <el-button type="primary" class="onlyBtn" @click="importSkFlg = true">导入商户</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" style="width:100%;margin-top: 20px;" border fit highlight-current-row
            :header-cell-style="{ background: '#f5f5f5' }" :default-sort="{ prop: 'rpTime', order: 'descending' }">
            <el-table-column align="center" label="宝付商户号" width="155">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.subId">
                        <p> {{ scope.row.subId }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
             <el-table-column align="center" label="支付宝商户号" width="155">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.subMchId">
                        <p> {{ scope.row.subMchId }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="loginAccount" label="登录账户" width="110"></el-table-column>
            <el-table-column prop="userName" label="姓名" width="80"></el-table-column>
            <el-table-column prop="userPhone" label="手机号"></el-table-column>
            <el-table-column prop="userCard" label="身份证号" width="150"></el-table-column>
            <el-table-column align="center" label="省-市-支行">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.bankAddr">
                        <p> {{ scope.row.bankAddr }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="企业名称">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.accName">
                        <p> {{ scope.row.accName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="企业编码">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.accNo">
                        <p> {{ scope.row.accNo }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="accPrice" label="注册资本" width="70"></el-table-column>
            <el-table-column align="center" label="开户状态" width="80">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.state == 0" :content="scope.row.stateName">
                        <p> {{ scope.row.stateName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.state == 1" :content="scope.row.stateName">
                        <p style="color:green"> {{ scope.row.stateName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.remark">
                        <p style="color:crimson"> {{ scope.row.stateName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="报备状态" width="80">
                <template v-slot="scope">
                    <el-tooltip v-if="scope.row.baoState == 0" :content="scope.row.baoName">
                        <p> {{ scope.row.baoName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.baoState == 1" :content="scope.row.baoName">
                        <p style="color:rgb(100, 128, 0)"> {{ scope.row.baoName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else-if="scope.row.baoState == 2" :content="scope.row.baoName">
                        <p style="color:green"> {{ scope.row.baoName }}</p>
                    </el-tooltip>
                    <el-tooltip v-else :content="scope.row.baoRemark">
                        <p style="color:crimson"> {{ scope.row.baoName }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column align="center" label="开户备注">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.remark">
                        <p> {{ scope.row.remark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="报备备注">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.baoRemark">
                        <p> {{ scope.row.baoRemark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="时间" width="140"></el-table-column>
            <el-table-column label="操作" align="center" width="210">
                <template slot-scope="scope">
                    <el-button @click="goToInfoFailPage(scope.row, $event)" v-if="scope.row.state != 1" type="text"
                        size="small">编辑</el-button>
                    <el-button @click="reloadData(scope.row.id)" v-if="scope.row.state == 2" type="text"
                        size="small">重试进件</el-button>

                    <el-button @click="reloadBaobei(scope.row.id)" v-if="scope.row.baoState == 0 || scope.row.baoState == 3"
                        type="text" size="small">去报备</el-button>

                    <el-button @click="selectBaobei(scope.row.id)"  type="text"
                        size="small">报备查询</el-button>

                    <el-button @click="deleteData(scope.row.id)" style="color: red;" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>




        <el-dialog :append-to-body="true" title="导入数据" :visible.sync="importSkFlg" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('agentCount/importExcel')" :headers="setHeader()"
                        :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="服务商号：" prop="ChannelId">
                    <el-col :span="22">
                        <el-input v-model.trim="batchOptForm.ChannelId" clearable></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="服务商名称：" prop="ChannelName">
                    <el-col :span="22">
                        <el-input v-model.trim="batchOptForm.ChannelName" clearable></el-input>
                    </el-col>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div>
        </el-dialog>





        <el-dialog :append-to-body="true" title="编辑商户信息" :visible.sync="baofuFlg" width="600px" @close="baofuFlg = false"
            :close-on-click-modal="false">
            <el-form ref="baoFuData" :model="baoFuData" label-width="120px">
                <el-form-item label="邮箱：" prop="email">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.email" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="登录账户：" prop="loginAccount">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.loginAccount" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="姓名：" prop="userName">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.userName" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="手机号：" prop="userPhone">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.userPhone" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="身份证：" prop="userCard">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.userCard" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="银行名称：" prop="bankName">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.bankName" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="地址-开户行：" prop="bankAddr">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.bankAddr" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="银行卡号：" prop="cardNo">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.cardNo" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="卡号开户名：" prop="cardName">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.cardName" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="公司名称：" prop="accName">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.accName" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="公司编号：" prop="accNo">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.accNo" clearable></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="注册金额：" prop="accPrice">
                    <el-col :span="22">
                        <el-input v-model.trim="baoFuData.accPrice" clearable></el-input>
                    </el-col>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="baofuFlg = false">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import common from '@/utils/common.js'
import { getBgdRechargeList, getBgdRechargeFailLists, getPkgListOfGroup } from '@/api/sim.js'
export default {
    data() {
        return {
            batchOptForm: {
                state: '',
                ChannelName: '微众盈科（深圳）技术有限公司',
                ChannelId: '2088741505623326',
            },
            importSkFlg: false,

            currentId_fail: '',
            stockForm: {
                yearTime: '',
                monthTime: '',
                chgNum: '',
                skNum: '',
            },

            textRemark: '无次月停机',
            editVisibale: false,
            editForm: {
                type: "",
                supplierNames: '',
                supplierCodes: [],
            },
            branchSupplierOption: [],



            searchForm: {
                lunState: '',
                name: '',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            failVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            baoFuData: {
                id: '',
                email: '',
                loginAccount: '',
                userName: '',
                userPhone: '',
                userCard: '',
                bankName: '',
                bankAddr: '',
                accName: '',
                accPrice: '',
                cardNo: '',
                accNo: '',
                cardName: '',
            },
            baofuFlg: false,



        }
    },
    methods: {
        addOrEidtPkgHandle() {
            common.sysRequest('agentCount/baofuUpdate', this.baoFuData, 'post').then(res => {
                if (res.data.code == 200) {
                    this.baofuFlg = false;
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        //失败列表
        goToInfoFailPage(row, $event) {
            for (var key in row) {
                this.baoFuData[key] = row[key]
            }
            this.baofuFlg = true;
        },





        sureBatchChgStateHandler() {
            this.$refs.batchOptForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getListPageHandle();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },



        confirmHandler() {
            var d = {
                ...this.editForm
            }
            d.supplierCodes = d.supplierCodes.join("，");
            let path = "lunxun/manage/state";
            common.sysRequest(path, d, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.cancel();
                    this.getListPageHandle();

                } else {
                    this.$message.error(res.data.message);
                }
            })

        },
        showSimManage(type) {
            if (type == 2) {
                this.textRemark = '有可用套餐复机'
            } else {
                this.textRemark = '无次月停机';
            }
            this.editForm.type = type;
            this.editVisibale = true;
        },

        chooseAll() {
            let val = [];
            for (let i in this.branchSupplierOption) {
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll() {
            this.editForm.supplierCodes = [];
        },



        deleteData(id) {
            this.$confirm("确定要删除嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('agentCount/baofuDelete', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getListPageHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        reloadData(id) {
            this.$confirm("确定要重试嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('agentCount/baofuReload', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getListPageHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        reloadBaobei(id) {
            this.$confirm("确定要报备嘛？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('agentCount/toBaobei', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getListPageHandle();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            })
        },
        selectBaobei(id) {
            var data = {
                id: id
            }
            common.sysRequest('agentCount/baobeiSelect', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        cancel() {
            this.editForm = {
                type: "",
                supplierCodes: [],
            }
            this.editVisibale = false;
            this.failVisible = false;
            this.importSkFlg = false;
        },
        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('agentCount/baofuList', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },

        handleCurrentChange(val) {
            if (this.failVisible) {
                this.tbpg_fail.currentPage = val
                this.goToInfoFailPage(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val
                this.getListPageHandle();
            }
        },
        //执行sim卡轮训
        lunXunSimTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '如果有轮训尚未结束，请勿重复执行轮训！确定要手动执行SIM卡轮训吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.getListPageHandle();
                                this.$message.success(res.data.message);
                                done();
                            } else {
                                this.$message.error(res.data.message);
                                done();
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })


        },
        //执行代理商统计
        lunXunAgentTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行代理商统计吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/agentCount', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunPauseTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行没有次月套餐停机吗？此操作请谨慎操作！')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/pause/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        lunXunActiveTimer() {
            const h = this.$createElement;
            this.$msgbox({
                title: '执行轮训',
                message: h('p', null, [
                    h('span', null, '确认要手动执行有有效套餐复机吗？')
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        let iccid = 1;
                        common.sysRequest('lunxun/active/sim', iccid, 'get').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.getListPageHandle();
                                done();
                            } else {
                                this.$message.error(res.data.message);
                            }
                        }
                        )
                    } else {
                        done();
                    }
                }
            })

        },
        //重新购买
        buyPkgReload(rowData) {
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo: rowData.downOrder,
                isNextMonth: rowData.isNextMonth,
                packgeId: rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        }


    },

    created() {
        common.getPkgGroupListCom(this, 'branchSupplierOption');
        this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;;
        this.getListPageHandle();
    },
    mounted() {
        this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;
    },
    computed: {
        fluxPollDetailIccid: function () {
            return this.$store.state.menu.fluxPollDetailIccid;;
        },

    },

    watch: {
        fluxPollDetailIccid: function () {
            this.searchForm.name = this.$store.state.menu.fluxPollDetailIccid;;
            this.getListPageHandle();
        },
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }

    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

